<section class="related-notes" *ngIf="!empty && isLoggedIn && userStreams.length > 0">
    <h2>Other notes like this one</h2>
    <div class="prelaoder" *ngIf="loading">
        <fa-icon [icon]="['fas', 'sync']" [spin]="true" [size]="'lg'"></fa-icon>
    </div>
    <div class="notes-wrapper">
        <div class="note-wrapper" *ngFor="let note of notes" [hidden]="loading">
          <img-lazy-loading
            class="note-img"
            *ngIf="note && note.thumbnails && note.thumbnailImage"
            [mainThumb]="note.thumbnailImage"
            [thumbs]="note.thumbnails"
            [url]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
            [title]="'Read more about ' + note.name"></img-lazy-loading>
            <div class="note-details">
              <a
                [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]" title="Read about {{note.name}}"
                class="note-title">{{note.name}}</a>
              <p class="note-description">{{note.firstLeadWords}}</p>
              <div class="other-details" *ngIf="note.user">
                <a
                  class="by-user"
                  [routerLink]="['/user', note.userId, 'profile']"
                  *ngIf="note.user">
                  <img 
                    class="avatar"
                    *ngIf="note.user && note.user.profileImageUrl" [src]="note.user.profileImageUrl" />
                  {{note.user.displayName ? note.user.displayName : note.userDisplayName}}
                </a>
                <span class="date">{{note.published || note.created | date: 'MMM dd, yyyy' }}</span>
              </div>
            </div>
        </div>
    </div>
</section>
